import type theme from '#build/ui/alert'
import type { DeepPartial } from '@nuxt/ui'

const alert: DeepPartial<typeof theme> = {
  slots: {
    root: 'px-[30px] py-6 gap-4 rounded-none border-none tablet:gap-5 desktop:gap-6 md:px-[60px] xl:px-[80px]',
    wrapper: 'gap-0',
    title: 'font-body text-xl',
    description: 'font-body opacity-100 text-[15px] font-bold md:text-base',
    icon: 'tablet:size-6 desktop:size-8',
    close: '[&>svg]:size-6',
  },
  variants: {
    variant: {
      info: {
        root: 'bg-med-aqua',
        title: '',
        description: '',
        icon: '',
        close: '',
      },
      warning: {
        root: 'bg-med-orange dark-bg',
        title: '',
        description: '',
        icon: '',
        close: '',
      },
      success: {
        root: 'bg-med-light-gray',
        title: '',
        description: '',
        icon: '',
        close: '',
      },
    },
  },
  defaultVariants: {
    variant: 'info' as any,
  },
}

export default alert
